import styled, { css } from "styled-components"

export const Label = styled.label`
  display: block;
  font-family: system-ui;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 6px;
  ${props =>
    props.required &&
    css`
      &::after {
        margin-left: 2px;
        content: "*";
        color: red;
      }
    `};
`

export const Error = styled.div`
  color: red;
  font-size: 16px;
  font-weight: 700;
  margin-top: 6px;
`
